import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dfb65d8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-profile" }
const _hoisted_2 = { class: "user-profile--public-info" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "user-profile__username highlighted-text"
}
const _hoisted_5 = {
  key: 1,
  class: "user-profile__username highlighted-text"
}
const _hoisted_6 = {
  key: 2,
  class: "user-profile__biography"
}
const _hoisted_7 = {
  key: 3,
  class: "user-profile__biography"
}
const _hoisted_8 = { class: "action-buttons" }
const _hoisted_9 = { class: "user-profile--private-info" }
const _hoisted_10 = { class: "user-profile__personal-info" }
const _hoisted_11 = { class: "b-user-profile__personal-info b" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "personal-info__title" }, "Informações pessoais:", -1))
const _hoisted_13 = { class: "personal-info__list list" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" CPF: ")
const _hoisted_15 = {
  key: 0,
  class: "personal-info__text highlighted-text"
}
const _hoisted_16 = {
  key: 1,
  class: "personal-info__text highlighted-text"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Data de nascimento: ")
const _hoisted_18 = {
  key: 0,
  class: "personal-info__text highlighted-text"
}
const _hoisted_19 = {
  key: 1,
  class: "personal-info__text highlighted-text"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" E-mail: ")
const _hoisted_21 = { class: "personal-info__text highlighted-text" }
const _hoisted_22 = { class: "user-profile__interests" }
const _hoisted_23 = { class: "b-user-profile__interests b" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "interests__title" }, "Seus interesses:", -1))
const _hoisted_25 = {
  key: 0,
  class: "interests__list list"
}
const _hoisted_26 = { class: "highlighted-text" }
const _hoisted_27 = {
  key: 1,
  class: "interests__list"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Nenhum ", -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 0,
  class: "user-profile__activity"
}
const _hoisted_31 = { class: "b" }
const _hoisted_32 = { class: "activity__title" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Seus decoins: ")
const _hoisted_34 = { class: "highlighted-text bold" }
const _hoisted_35 = { class: "activity__list list" }
const _hoisted_36 = { class: "link" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "highlighted-text" }, "Visualizar extrato", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Suggestion = _resolveComponent("Suggestion")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "user-profile__pic",
        src: $setup.noCacheImage,
        alt: "Foto do usuário",
        onError: _cache[0] || (_cache[0] = 
          event =>
            (event.target.src = require('../../assets/static/onerror-user.png'))
        )
      }, null, 40, _hoisted_3),
      ($props.user.name)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString($setup.capitalizeUserName($props.user.name)), 1))
        : (_openBlock(), _createElementBlock("h2", _hoisted_5, " Usuário sem nome ")),
      ($props.user.biography)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($props.user.biography), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_7, " Você ainda não possui uma biografia. ")),
      _createElementVNode("div", _hoisted_8, [
        ($setup.showButtonBoarding())
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn--boarding",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.redoOnBoarding && $setup.redoOnBoarding(...args)))
            }, " Refazer onboarding "))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "btn btn--boarding",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.openSuggestion()))
        }, " Dê sua sugestão "),
        _createVNode(_component_Suggestion, {
          isOpen: $setup.showConfirmation,
          onToggle: $setup.closeSuggestionModal
        }, null, 8, ["isOpen", "onToggle"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("ul", _hoisted_13, [
            _createElementVNode("li", null, [
              _createElementVNode("p", null, [
                _hoisted_14,
                ($props.user.document)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString($options.maskCPF($props.user.document)), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString($options.maskCPF("00000000000")), 1))
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("p", null, [
                _hoisted_17,
                ($props.user.birthDate)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString($options.formatBirthDate($props.user.birthDate)), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_19, "--/--/----"))
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("p", null, [
                _hoisted_20,
                _createElementVNode("span", _hoisted_21, _toDisplayString($props.user.email), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          ($props.interests.length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_25, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.interests, (interest, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                    _createElementVNode("span", _hoisted_26, _toDisplayString(interest.title), 1)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29))
        ])
      ]),
      ($options.isDecolaTemplate())
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("h4", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("span", _hoisted_34, _toDisplayString($setup.toDecoins($props.user.dcoins)), 1)
              ]),
              _createElementVNode("ul", _hoisted_35, [
                _createElementVNode("li", _hoisted_36, [
                  _createVNode(_component_router_link, { to: { name: 'statement' } }, {
                    default: _withCtx(() => [
                      _hoisted_37
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}